import {DOWNLOAD_CLEANING_PLAN_SUCCESS} from "../../reducers/cleaningPlanReducer";


export const downloadCleaningPlanSuccess = () =>{
    return {
        type: DOWNLOAD_CLEANING_PLAN_SUCCESS
    }
}